var map = {
	"./adminAvatar/DanAvatar.png": 942,
	"./adminAvatar/GergelyAvatar.png": 943,
	"./adminAvatar/avatarHeader.png": 944,
	"./adminAvatar/userDefaultAvatar.png": 399,
	"./avatarHeader.png": 1831,
	"./bg-blue.png": 1832,
	"./bg-green.png": 1833,
	"./bg-purple.png": 1834,
	"./bg-red.png": 1835,
	"./cardImage.png": 945,
	"./img-default.png": 400,
	"./levicaLogo.svg": 684,
	"./login.jpg": 66,
	"./mail.png": 938,
	"./pass.png": 937,
	"./qrCode.png": 1836,
	"./userDefaultAvatar.jpg": 147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1830;